import { rejectSeedingProposal } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type { RejectSeedingProposalServiceRequest } from './reject-seeding-proposal.dto';
import {
  RejectSeedingProposalServiceRequestSchema,
  RejectSeedingProposalServiceResponseSchema,
} from './reject-seeding-proposal.dto';

export const rejectSeedingProposalService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(RejectSeedingProposalServiceRequestSchema),
    // NOTE: 204 No Content — 응답 본문 없이 await 만. BE 가 에러면 withApiErrorCapture 가 throw.
    async (request: RejectSeedingProposalServiceRequest): Promise<void> => {
      await rejectSeedingProposal(request);
    },
    validateServiceResponse(RejectSeedingProposalServiceResponseSchema),
  ),
);
